<div class="container-fluid vh-100 d-flex flex-column p-0">
  <!-- Header with sidebar intersection handling -->
  <div class="d-flex header-container">
    <!-- Sidebar header section with logo -->
    <div class="sidebar-header-section d-flex justify-content-center align-items-center">
      <img src="assets/images/logo-mapoh.png" alt="Mapoh Logo" height="40">
    </div>
    
    <!-- Main header -->
    <header class="mapoh-header d-flex justify-content-between align-items-center flex-grow-1">
      <div class="d-flex align-items-center">
        <h2 class="mb-0 fw-normal">{{ pageTitle }}</h2>
      </div>
      <div class="d-flex align-items-center">
        <!-- Avatar con iniciales del usuario -->
        <div class="user-avatar rounded-circle me-2 d-flex align-items-center justify-content-center" 
             [title]="fullUserName">
          {{ userInitials }}
        </div>
        
        <!-- Luego "Bienvenido [Nombre Completo]" -->
        <div class="me-4 text-center">
          <div class="small text-muted">Bienvenido</div>
          <div class="fw-medium">{{ fullUserName }}</div>
        </div>
        
        <!-- Luego notificaciones -->
        <div class="d-flex align-items-center me-4">
          <a [routerLink]="['/notificaciones']" class="position-relative" style="cursor: pointer;">
            <img src="assets/images/Notification.png" alt="Notificaciones" width="24">
            <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-light text-dark">2</span>
          </a>
        </div>
        
        <!-- Por último cerrar sesión (que ya estaba bien) -->
        <a class="btn btn-link text-dark" (click)="logout()">
          <img src="assets/images/Logout.png" alt="Cerrar sesión" width="24" class="me-1">
          <span>Cerrar sesión</span>
        </a>
      </div>
    </header>
  </div>

  <!-- Contenido principal con sidebar -->
  <div class="d-flex flex-grow-1 overflow-hidden">
    <!-- Sidebar -->
    <div class="mapoh-sidebar d-flex flex-column bg-white">
      <nav class="flex-grow-1">
        <ul class="list-unstyled p-0 m-0">
          <li *ngFor="let item of visibleMenuItems">
            <a [routerLink]="[item.route]" routerLinkActive="active" class="nav-link sidebar-link d-flex align-items-center">
              <i class="fas {{ item.icon }} me-2" style="width: 24px; font-size: 18px;"></i>
              <span>{{ item.label }}</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>

    <!-- Main Content -->
    <div class="flex-grow-1 overflow-auto" style="background-color: #f8f9fa;">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
